import { Route, Routes } from 'react-router-dom';
import { ProtectedRoute } from './layout/ProtectedRoute';
import { Shell } from './layout/Shell';
import { AuditLog } from './routes/AuditLog';
import { AuthCallback } from './routes/AuthCallback';
import { AuthLogin } from './routes/AuthLogin';
import { Dashboard } from './routes/Dashboard';
import { LineUserDetail } from './routes/LineUserDetail';
import { LineUserList } from './routes/LineUserList';
import { Placeholder } from './routes/Placeholder';
import { Users } from './routes/Users';

export function App(): JSX.Element {
  return (
    <Routes>
      <Route path="/auth/login" element={<AuthLogin />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route
        element={
          <ProtectedRoute>
            <Shell />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="line-users" element={<LineUserList />} />
        <Route path="line-users/:userId" element={<LineUserDetail />} />
        <Route
          path="flow"
          element={
            <ProtectedRoute minRole="editor">
              <Placeholder title="フロー編集" />
            </ProtectedRoute>
          }
        />
        <Route
          path="prompts"
          element={
            <ProtectedRoute minRole="editor">
              <Placeholder title="プロンプト編集" />
            </ProtectedRoute>
          }
        />
        <Route
          path="audit"
          element={
            <ProtectedRoute minRole="editor">
              <AuditLog />
            </ProtectedRoute>
          }
        />
        <Route
          path="users"
          element={
            <ProtectedRoute minRole="admin">
              <Users />
            </ProtectedRoute>
          }
        />
      </Route>
      <Route path="*" element={<main className="p-8">Not Found</main>} />
    </Routes>
  );
}
